import type { TemplateOnlyComponent as TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import SettingsMyHotelFormHotelDetails from 'lumen/components/settings/my-hotel/form-hotel-details';
import SettingsPageTemplate from 'lumen/components/settings/page-template';
import type HotelSettingsMyPropertyHotelDetailsController from 'lumen/controllers/hotel/settings/my-property/hotel-details';

interface HotelSettingsMyPropertyHotelDetailsSignature {
  Args: {
    controller: HotelSettingsMyPropertyHotelDetailsController;
  };
}

const HotelSettingsMyPropertyHotelDetailsTemplate = <template>
  <SettingsPageTemplate
    @description={{t "settings.my_hotel.hotel_details.description"}}
    @title={{t "settings.my_hotel.hotel_details.title"}}
    @type="container"
  >
    <SettingsMyHotelFormHotelDetails @model={{@controller.formModel}} />
  </SettingsPageTemplate>
</template> satisfies TOC<HotelSettingsMyPropertyHotelDetailsSignature>;

export default HotelSettingsMyPropertyHotelDetailsTemplate;
